export default function scrollIntoView(el, parent) {
   const { top } = el.getBoundingClientRect();
   const rect = parent.getBoundingClientRect();

   const startPosition = parent.scrollTop;
   const delta = Math.floor(top - rect.top);

   parent.scrollTop = startPosition + delta;
}
